import { render, staticRenderFns } from "./CarVisitDetail.vue?vue&type=template&id=4a1cb484&"
import script from "./CarVisitDetail.vue?vue&type=script&lang=js&"
export * from "./CarVisitDetail.vue?vue&type=script&lang=js&"
import style0 from "./CarVisitDetail.vue?vue&type=style&index=0&rel=stylesheet%2Fless&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports